import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { Nullable } from '@/utils/types';
import { formatToSF } from '@/bundles/GroupFilters/helpers/formatters/formatToSF';

export const getRefrigerationFiltersConfigByType = (type: string): IFilterConfigItem[] => [
  {
    title: 'Freezer Size (SF)',
    name: `${type}_freezer_size`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.refrigeration,
    formatter: (v: Nullable<number>) => formatToSF(v),
  },
  {
    title: 'Cooler Size (SF)',
    name: `${type}_cooler_size`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.refrigeration,
    formatter: (v: Nullable<number>) => formatToSF(v),
  },
  {
    title: 'Freezer OR Cooler Size (SF)',
    name: `${type}_freezer_cooler_size`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.refrigeration,
    formatter: (v: Nullable<number>) => formatToSF(v),
  },
  {
    title: 'HVAC Warehouse (SF)',
    name: `${type}_hvac_warehouse`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.refrigeration,
    formatter: (v: Nullable<number>) => formatToSF(v),
  },
];
